import { DataSource, Layout, Switch, Table} from "@mcleod/components";

export abstract class AutogenLayoutTableCarrierDeliveredOrders extends Layout {
	sourceCarrierDeliveredOrders: DataSource;
	switchUnpaid: Switch;
	tableCarrierDeliveredOrders: Table;
}
